<template>
	<div class="content">
		<h1 class="question">{{ question.title }}</h1> 
		<li class="option" :class="{'checked': selectedItem==item}" v-for="item in question.options" @click="select(item,$event)"> {{ item.text }} </li>
		<div class="next-btn" :class="{'disable':btnDisable}" @click="goNext"><span v-if="complete">完成</span><span v-if="!complete">下一题</span></div>
	</div>
</template>

<script>
  export default {
    props: ['question', 'complete'],
    data () {
      return {
        score: 0,
        selectedItem: {},
        btnDisable: true
      }
    },
    methods: {
      select: function (item, e) {
        this.score = item.score
        this.selectedItem = item
        this.btnDisable = false
      },
      goNext: function () {
        if (this.btnDisable) {
          return false
        }
        var t = {}
        t[this.question.qId] = this.selectedItem.aId
        this.$dispatch('goNext', this.score, t)
        this.btnDisable = true
      }
    }
  }
</script>

<style scoped>
  .content{
      padding: 0rem;
  }
  .question{
      background: url(../assets/question_icon.png) no-repeat;
      font-weight: normal;
      padding-left: 3.5rem;
      background-size: 2.5rem 2rem;
      font-size: 2rem;
      margin: 2rem 1rem;
      color:#333;
  }
  .option{
      list-style: none;
      font-size: 1.5rem;
      padding: 1.2rem 3.5rem;
      margin: 0.8rem 0;
      color:#666;
      background: url(../assets/list_point.png) no-repeat  #fff;
      background-size: 0.4rem;
      background-position: 2rem 2rem;
  }
  .option.checked{
      background-image: url(../assets/checkmark.png);
      background-size: 1rem 1rem;
      background-position: 2rem 1.8rem;
  }
  .next-btn{
      width: 80%;
      margin: 1.5rem auto 0;
      text-align: center;
      background: #d94b40;
      font-size: 1.5rem;
      padding: 1rem;
      color: #fff;
      border-radius: 0.5rem;
      font-weight: normal;
}
.next-btn.disable{
  background: #F9AFA9;
}
</style>


/** WEBPACK FOOTER **
 ** radioList.vue?38830f06
 **/